export default "__VITE_ASSET__CYPkxHAM__"